import { useEffect, useState } from 'react';
import { storageService } from 'infrastructure/services/StorageService';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const checkAuth = async () => {
      setIsLoading(true);
      const token = await storageService.getItem('accessToken');
      const refreshToken = await storageService.getItem('refreshToken');
      setIsAuthenticated(!!token && !!refreshToken);
      setIsLoading(false);
    };

    checkAuth().then();
  }, []);

  return { isAuthenticated, isLoading };
};
